import React, { Component } from 'react'
import ProjectCollection from '../ProjectCollection/ProjectCollection'
import me from '../../assets/images/Takashi-2.png'
import './style.css'

class Home extends Component {
    componentDidMount(){
      console.log("THE");
      console.log(this.props);
    }

    render(){
      var animatedStyle
      if(!this.props.homeRevisit){
        animatedStyle = {
          text : {
            animation: "helloText 1.4s 2.4s backwards"
          },
          header : {
            animation: "hello 3.1s 0.2s backwards"
          },
          image : {
            animation: "helloImg 2.2s 1.0s backwards"
          },
          work : {
            animation: "work 1s 3s backwards"
          }
        }
      } else {
        animatedStyle = {
          text : {
            animation: "work 1.4s 0.2s backwards"
          },
          header : {
            animation: "work 1.4s 0.1s backwards"
          },
          image : {
            animation: "work 1.4s 0.3s backwards"
          },
          work : {
            animation: "work 1.4s 0.4s backwards"
          }
        }
      }



      return(
      <main>
        <div className="hello">
          <div className="helloChild red">
          <h2 style={animatedStyle.header}>hey there, I&apos;m <span className="name">Takashi Wickes</span></h2>
          <img style={animatedStyle.image} src={me} />
          </div>   
          <div className="helloChild yellow">        
          <p style={animatedStyle.text}>I am an Visual Interaction Design Lead at the IDEO Play Lab.</p>
          <p style={animatedStyle.text}>Currently at IDEO, my focus has been on tackling problems for clients with either in-field prototyping and testing or designing frameworks to enable teams to tackle design challenges themselves.</p>
          </div>
        </div>
        <div className="work" style={animatedStyle.work}>
          <h2>and here are my featured projects</h2>
          <ProjectCollection linkBack="/"/>
          <h2>and here is some more of what I have built</h2>
          <ProjectCollection isArchive="true" linkBack="/"/>
        </div>
        <div className="links">
          <h2>aaaaaaaaand if you want more, you can find it here. Thanks!!</h2>
          <a href="https://dribbble.com/takashiw"><p>Dribbble</p></a>
          <a href="http://github.com/takashiw"><p>GitHub</p></a>
          <a href="http://be.net/takashiw"><p>Behance</p></a>
          <a href="https://twitter.com/takashiwickes"><p>Twitter</p></a>
          <a href="http://www.linkedin.com/in/takashiw"><p>Linkedin</p></a>
          <a href="http://takashiwickes.com/resume.pdf"><p>Resume</p></a>
        </div>
      </main>
    )}

}

export default Home



// WEBPACK FOOTER //
// ./src/components/Home/Home.js